// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__363su","requiredAsterisk":"Info_requiredAsterisk__1eWnE"};